import { useState } from "react";
import { ChatMessageInput } from "./ChatMessageInput";
import { ChatMessageList } from "./ChatMessageList";
import { ChatThreadMessage } from "./types/chat-thread-message";
import type { JobOfferViewMode } from "../job-offer/matching/job-offer-card-with-data";
import { DraftFormAssignmentGate } from "./draft-form-assignment-gate";
import {
  EndedRelationshipNotice,
  type EndedRelationshipLookup,
} from "./ended-relationship-notice";

export const ChatThreadBody = ({
  messages,
  onSendMessage,
  readOnly = false,
  threadId,
  viewMode,
  user,
  organizationBusinessUnitId,
  recipientUserId,
  canManageJobPosts,
  documentSigningEnabled,
  providerDisplayName,
  onFormAssignmentSent,
  initialMessage,
  endedRelationshipLookup,
}: {
  messages: ChatThreadMessage[];
  onSendMessage: (message: string, attachmentIds?: string[]) => Promise<void>;
  readOnly?: boolean;
  threadId: string;
  viewMode?: JobOfferViewMode;
  user?: { is_admin: boolean } | null;
  organizationBusinessUnitId?: string;
  recipientUserId?: string;
  canManageJobPosts?: boolean;
  documentSigningEnabled?: boolean;
  providerDisplayName?: string;
  onFormAssignmentSent?: (chatThreadId: string) => void;
  initialMessage?: string;
  /** Org-side chats with a provider: shows a notice once the relationship ended. */
  endedRelationshipLookup?: EndedRelationshipLookup;
}) => {
  const [isDraftBlocking, setIsDraftBlocking] = useState(false);

  return (
    <>
      <ChatMessageList
        messages={messages}
        threadId={threadId}
        viewMode={viewMode}
        user={user}
      />
      {!readOnly && (
        <DraftFormAssignmentGate
          organizationBusinessUnitId={organizationBusinessUnitId}
          recipientUserId={recipientUserId}
          canManageJobPosts={canManageJobPosts}
          documentSigningEnabled={documentSigningEnabled}
          providerDisplayName={providerDisplayName}
          onBlockingChange={setIsDraftBlocking}
          onFormAssignmentSent={onFormAssignmentSent}
        />
      )}
      {endedRelationshipLookup && (
        <EndedRelationshipNotice {...endedRelationshipLookup} />
      )}
      <ChatMessageInput
        key={threadId}
        onSend={onSendMessage}
        readOnly={readOnly}
        disabled={isDraftBlocking}
        threadId={threadId}
        organizationBusinessUnitId={organizationBusinessUnitId}
        recipientUserId={recipientUserId}
        canManageJobPosts={canManageJobPosts}
        documentSigningEnabled={documentSigningEnabled}
        onFormAssignmentSent={onFormAssignmentSent}
        initialMessage={initialMessage}
      />
    </>
  );
};
